import { registerSW } from 'virtual:pwa-register';
import { decideUpdate } from './pwaPolicy';

/**
 * Service worker updates (registerType 'prompt'): a deploy must reach open tabs
 * without making anyone lose a half-filled form.
 *
 * - A new version found while the page is still starting (pwaPolicy FRESH_MS) is applied
 *   at once: nothing has been typed yet, so the reload is invisible.
 * - Found later (an hourly or on-focus check), it is applied when the tab is
 *   next hidden, so the shopper or merchant comes back to the new version.
 * - Every time the tab comes back into view we ask the server for a new worker.
 */
const CHECK_EVERY_MS = 60 * 60 * 1000;

export function startPwaUpdates() {
  if (!('serviceWorker' in navigator)) return;
  const loadedAt = Date.now();
  let pending = false;
  let updateSW = () => {};

  const apply = () => updateSW(true);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && pending) apply();
  });

  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (decideUpdate({ sinceLoadMs: Date.now() - loadedAt, hidden: document.hidden }) === 'now') apply();
      else pending = true;
    },
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const check = () => registration.update().catch(() => undefined);
      setInterval(check, CHECK_EVERY_MS);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) check();
      });
    },
  });
}
